module.exports = __webpack_public_path__ + "img/17_41.70b7ff84.png";